import { SPage } from 'servisofts-component2';
import MessageInfo from './MessageInfo';
import MessageAlert from './MessageAlert';
import ChecklistAssignedTrailer from './ChecklistAssignedTrailer';
import ChecklistQuestion from './ChecklistQuestion';
import ChecklistImageCollection from './ChecklistImageCollection';
import ChecklistTiposVehiculos from './ChecklistTiposVehiculos';
import ChecklistChoferes from './ChecklistChoferes';
import ChecklistVehiculos from './ChecklistVehiculos';
import ChecklistFotos from './ChecklistFotos';

export default SPage.combinePages("check", {
    "": MessageInfo,
    "MessageInfo": MessageInfo,
    "MessageAlert": MessageAlert,
    "ChecklistAssignedTrailer": ChecklistAssignedTrailer,
    "ChecklistQuestion": ChecklistQuestion,
    "ChecklistImageCollection": ChecklistImageCollection,
    "ChecklistTiposVehiculos": ChecklistTiposVehiculos,
    "choferes": ChecklistChoferes,
    "vehiculos": ChecklistVehiculos,
    "fotos": ChecklistFotos,
});